import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'
import Link from 'components/Link'

const ActiveVehicleLimitMessage = () => {
    const { t, i18n } = useTranslation('errors')

    return (
        <ErrorMessageContent
            content={(
                <p>
                    {t('internal.1010.message')}
                </p>
            )}
            actions={(
                <Link
                    to={`${getLocale(i18n.language) || '/'}`}
                    className="button button--primary"
                    trackName="ok"
                >
                    {t('internal.1010.cta')}
                </Link>
            )}
        />
    )
}

export default ActiveVehicleLimitMessage
